<template>
  <div v-if="BranchDetail" id="cart" class="fs-site">
    <!-- Header Cart -->
    <el-row class="fs-entry-header fs-stick">
      <el-col :span="4" class="fs-close" @click.native="redirectToMenu">
        <i class="el-dialog__close el-icon el-icon-close"/>
      </el-col>
      <el-col :span="16" class="fs-header-topic">
        <label class="text-title--large">
          {{ $t('pageCheckout.cart') }}
       </label><br>
       <div class="truncate--2">
          <label class="text-subtitle">
            {{ $t("pageCheckout.restaurant") }}
            {{ BranchDetail.restaurantName }}
            {{ $t("pageCheckout.branch") }}
            {{ BranchDetail.name }}
          </label>
       </div>
      </el-col>
    </el-row>

    <el-row :class="UserLoginStatus ? 'px-0 grey-border-bottom' : 'px-0'">
      <!-- Address Info -->
      <!-- Order Type Delivery / Pickup -->
      <el-col
        class="text-center pa-4 grey-border-bottom"
        v-if="UserLoginStatus"
      >
        <div class="tab-destination">
          <el-row>
            <el-col
              id="dual-flag"
              :span="24"
              class="flex"
              v-if="
                BranchDetail.pickupFlag === '1' &&
                BranchDetail.deliveryFlag === '1'
              "
            >
            <BaseButton  
              class="text-heading3 primary"
              @click="orderType = true" 
              :class="orderType ? 'active': 'color-gray59--text'"
            >
                <template #prefix>
                  <img 
                    class="mr--2"
                    :src="orderType ? 
                      require('@/assets/icons/delivery_active.png') : 
                      require('@/assets/icons/delivery_inactive.png')
                    " 
                    width="22" 
                    height="22" 
                  />
                </template>
                {{ $t('pageMenuList.header.deliveryFlag') }}
              </BaseButton>
              <BaseButton 
                class="text-heading3 primary"
                @click="orderType = false" 
								:class="!orderType ? 'active': 'color-gray59--text'"
              >
                <template #prefix>
                  <img 
                    class="mr--1 mb--1"
                    :src="!orderType ? 
                      require('@/assets/icons/pickup_active.png') : 
                      require('@/assets/icons/pickup_inactive.png')
                    " 
                    width="22" 
                    height="22" 
                  />
                </template>
                {{ $t('pageMenuList.header.pickupFlag') }}
              </BaseButton>
            </el-col>
            <el-col :span="24" class="flex" v-else>
              <div v-if="BranchDetail.deliveryFlag === '1'" class="once-status">
                <div class="round-icon">
                  <i class="icon-delivery-active" />
                </div>
                <span>{{ $t("pageMenuList.header.deliveryFlag") }}</span>
              </div>
              <div
                v-else-if="BranchDetail.pickupFlag === '1'"
                class="once-status"
              >
                <div class="round-icon bag">
                  <i class="icon-food-bag-active" />
                </div>
                <span>{{ $t("pageMenuList.header.pickupFlag") }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="my-2 text-left" v-if="orderType" id="orderinfo">
          <el-row class="my-2">
            <el-col>
              <label v-if="UserInfo" class="text-heading3">
                <b>{{ $t("pageCheckout.customer") }}</b> :
                <span class="fw-sm"
                  >{{ UserInfo.name }} • {{ UserInfo.phone }}</span
                >
              </label>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7" class="pr--2">
              <Gmap
                v-if="selectedLocation"
								:position="{ lat: selectedLocation.lat, lng: selectedLocation.lng }" 
								:marker-icon="require('@/assets/icons/svg/pin.svg')"
            		:marker-size="{ height: 50, width: 50 }"
                :zoom="16"
								:readonly="true"
                height="100px"
                style="border-radius: 8px"
              />
              <div
                v-else
                @click="is_map = true"
                class="order-icon color-gray95 color-gray50--text"
                style="
                  height: 100px;
                  border-radius: 8px;
                  display: grid;
                  place-items: center;
                "
              >
                No address
              </div>
            </el-col>
            <el-col :span="17" class="d-grid" style="height: 100px">
              <div class="d-flex justify-space-between">
                <div>
                  <label class="text-subtitle--bold">
                    {{ $t("pageCheckout.deliveryaddress") }}
                  </label>
                </div>
                <div>
                  <a class="fl-right text-link fs-link" @click="is_map = true">
                    {{
                      selectedAddress
                        ? $t("pageCheckout.changeaddress")
                        : $t("pageCheckout.selectaddress")
                    }}
                  </a>
                </div>
              </div>
              <div :class="{ 'text-xs-center pb--4': !selectedAddress }">
                <label class="text-body">
                  {{
                    selectedAddress
                      ? selectedAddress
                      : $t("pageCheckout.noaddress")
                  }}
                </label>
              </div>
              <div v-if="selectedLocation">
                <a
                  class="color-info--text text-body"
                  target="_blank"
                  :href="
                    'https://www.google.com/maps/search/?api=1&query=' +
                    selectedLocation.lat +
                    ',' +
                    selectedLocation.lng
                  "
                >
                  {{ $t("pageCheckout.findmap") }}
                  <i class="el-icon-arrow-right" style="font-size: 10px" />
                </a>
              </div>
            </el-col>
            <!-- <el-col :span="17">
              <label class="text-subtitle--bold">
                {{ $t('pageCheckout.deliveryaddress') }}
                <a 
                  class="fl-right text-link fs-link" 
                  @click="is_map = true" 
                  v-if="!selectedAddress"
                >
                  {{ $t('pageCheckout.selectaddress') }}
                </a>
                <a 
                  class="fl-right text-link fs-link" 
                  @click="is_map = true" 
                  v-else
                >
                  {{ $t('pageCheckout.changeaddress') }}
                </a>
              </label>
              <label class="text-body" v-if="!selectedAddress">{{ $t('pageCheckout.noaddress') }}</label><br>
              <label class="text-body" else>{{ selectedLocation && selectedLocation.address }}</label>
              <a class="text-grey" target="_blank" :href="'https://www.google.com/maps/search/?api=1&query='+ lat +',' + lng">ดูเส้นทางบนแผนที่ <i class="el-icon-arrow-right"></i></a>
            </el-col> -->
          </el-row>
          <el-row class="my-2">
            <el-col>
              <label class="text-subtitle--bold">{{
                $t("pageCheckout.notedriver")
              }}</label>
              <el-input
                :ref="'notaion'"
                class="address-to-textarea text-subtitle overide-textarea mt--1"
                row="300"
                rows="1"
                maxlength="50"
                type="textarea"
                :placeholder="$t('pageCheckout.placeholderdriver')"
                v-model="InputDeliveryNote"
              >
              </el-input>
            </el-col>
          </el-row>
        </div>
        <div class="text-left" v-else>
          <el-row class="my-2">
            <el-col>
              <label class="text-heading3--bold" v-if="BranchDetail">{{
                $t("pageCheckout.descriptionPickup")
              }}</label>
            </el-col>
          </el-row>
          <el-row class="my-2">
            <el-col :span="7" class="pr--2">
              <Gmap 
                :zoom="16"
								:position="{ lat: BranchDetail.latitude, lng: BranchDetail.longitude }" 
								:marker-icon="require('@/assets/icons/svg/pin.svg')"
            		:marker-size="{ height: 50, width: 50 }"
								:readonly="true"
                height="100px"
                style="border-radius: 8px"
              />
            </el-col>
            <el-col :span="17">
              <label class="fs-lh-12 fs-wrp-1 text-subtitle--bold"
                >{{ $t("pageCheckout.restaurant") }}
                {{ BranchDetail.restaurantName }}</label
              >
              <label class="fs-lh-12 fs-wrp-1 text-subtitle--bold"
                >{{ $t("pageCheckout.branch") }} {{ BranchDetail.name }}</label
              >
              <label class="text-body color-info--text">{{
                BranchDetail.address
              }}</label>
              <br />
              <a
                class="text-body color-info--text"
                target="_blank"
                :href="
                  'https://www.google.com/maps/search/?api=1&query=' +
                  BranchDetail.latitude +
                  ',' +
                  BranchDetail.longitude
                "
              >
                {{ $t("pageCheckout.findmap") }}
                <i class="el-icon-arrow-right" style="font-size: 10px" />
              </a>
            </el-col>
          </el-row>
          <label class="text-subtitle--bold">{{
            $t("pageCheckout.note")
          }}</label>
          <el-input
            :ref="'notaion'"
            row="300"
            rows="1"
            maxlength="50"
            type="textarea"
            class="text-subtitle overide-textarea mt--1"
            :placeholder="$t('without.text4')"
            v-model="InputPickupNote"
          >
          </el-input>
        </div>
        <!-- Preorder Time -->
        <el-row class="mt-2" v-if="PreOrderDetail">
          <!-- CASE Preorder 1 Phase 3.0 -->
          <el-col :span="20" class="text-left d-flex align-center" v-if="PreOrderTime.length == 0">
            <i class="el-icon-time fs-time" />
            <label class="text-heading3 ml--2">
              <b>
                {{
                  orderType
                    ? $t("pageCheckout.deliverytime")
                    : $t("pageCheckout.pickuptime")
                }}
                :
              </b>
              {{ $t("pageCheckout.deliverynow") }}
            </label>
          </el-col>
          <el-col :span="20" class="text-left" v-else>
            <i class="el-icon-time fs-time" />
            <label class="text-heading3 ml--2">
              <b>
                {{
                  orderType
                    ? $t("pageCheckout.deliverytime")
                    : $t("pageCheckout.pickuptime")
                }}
                :
              </b>
              {{ PreOrderTime[0] }}
            </label>
          </el-col>
          <!-- Check != CASE Preorder 5 Phase 3.0 -->
          <el-col
            :span="4"
            class="text-right"
            v-if="
              !(
                PreOrderDetail.deliveryTime.isOpen &&
                !PreOrderDetail.preOrderSetting.preorderFlag &&
                PreOrderDetail.orderNowSetting.orderNowFlag
              )
            "
          >
            <label class="text-link fs-link" @click="changePreorderTime">{{
              $t("pageCheckout.change")
            }}</label>
          </el-col>
        </el-row>
      </el-col>

      <!-- Cart List -->
      <!-- Menu -->
      <el-col class="pa-4">
        <el-row>
          <el-col class="text-left" :span="12">
            <label class="text-title--large">{{
              $t("pageCheckout.orderlist")
            }}</label>
          </el-col>
          <el-col class="text-right" :span="12">
            <label class="text-link fs-link" @click="gomenu">{{
              $t("pageCheckout.ordermore")
            }}</label>
          </el-col>
        </el-row>
        <el-row v-if="isSoldOut > 0">
          <el-col class="fs-sold-out mt-2">
            <el-row class="pa-2">
              <el-col :span="2" class="text-left">
                <i class="el-icon-warning-outline fs-sold"></i>
              </el-col>
              <el-col :span="14">
                <p class="my-0 fs-12 fw-md fs-sold">
                  {{ $t("pageCheckout.lostorder") }} <br /><em
                    class="fs-st-n fw-sm"
                    >{{ $t("pageCheckout.deleteorder1") }}</em
                  >
                </p>
              </el-col>
              <el-col :span="8" class="text-right">
                <el-button
                  class="fs-btn-sold fs-12 fw-sm"
                  @click="deleteSoldOutInCart"
                  >{{ $t("pageCheckout.deleteorder2") }}</el-button
                >
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row class="py-2 cart-list" v-for="(menu, i) in AmountCart" :key="i">
          <el-col>
            <el-row>
              <el-col
                :span="7"
                v-if="menu.imageUrl != 'restaurant/add_menu_edit_no_image.png'"
              >
                <el-image :class="menu.is_sold_out ? 'fs-gray-scale fs-img-border fs-crop' : 'fs-img-border fs-crop'"
                  :src="'https://images.foodstory.co/' + menu.imageUrl"
                  fit="cover"
                />
              </el-col>
              <el-col :class="!menu.is_sold_out ? 'fs-entry-wrap' : 'fs-gray-scale fs-entry-wrap'" :span="
                  menu.imageUrl != 'restaurant/add_menu_edit_no_image.png'
                    ? 11
                    : 18
                "
                v-if="Object.keys(menu).length"
              >
                <label class="text-heading3--med">{{ menu.name }}</label>
                <el-col>
                  <li
                    class="text-body text-grey"
                    v-for="(option, index) in menu.options"
                    :key="index"
                  >
                    {{ option.name }}
                    {{ option.qty > 1 ? "x" + option.qty : "" }}
                  </li>
                </el-col>
                <el-col>
                  <label class="notaion text-body">{{ menu.notaion }}</label>
                </el-col>
              </el-col>
              <el-col class="text-right" :span="6">
                <label
                  :class="
                    menu.is_sold_out
                      ? 'fs-gray-scale text-heading--bold'
                      : 'text-heading--bold'
                  "
                >
                {{ menu.subtotal | priceFormat(roundingType,currency) }}</label
                ><br />
                <label
                  v-if="menu.is_sold_out"
                  class="fs-sold text-heading2--med"
                >
                  {{ $t("pageCheckout.lostorder2") }}
                </label>
              </el-col>
              <el-col class="pt-1" :span="24">
                <el-row>
                  <el-col class="text-left" :span="4">
                    <el-button
                      :class="
                        menu.is_sold_out ? 'fs-delete-sold' : 'edit-menu-class'
                      "
                      icon="el-icon-delete"
                      @click="deleteMenuInCart(menu, i)"
                    >
                    </el-button>
                  </el-col>
                  <el-col class="text-right" :span="12">
                    <el-button
                      class="fs-gray-scale edit-menu-class"
                      v-if="menu.is_sold_out"
                      icon="el-icon-edit"
                    ></el-button>
                    <el-button
                      class="edit-menu-class"
                      v-else
                      @click="editMenuDetail(menu, i)"
                      icon="el-icon-edit"
                    ></el-button>
                  </el-col>
                  <el-col class="text-right" :span="8">
                    <elementCheckout
                      class="text-heading3--bold"
                      :display="menu.is_sold_out ? false : true"
                      :qty="menu.qty"
                      :subtotal="menu.subtotal"
                      :index="i"
                      :menudetail="menu"
                      :options="menu.options"
                      :branchdetail="BranchDetail"
                      :notaion="menu.notaion"
                      :flag="'checkout'"
                    />
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row v-if="AmountCart">
          <el-col class="text-center" v-if="AmountCart.length === 0">
            <h4 class="text-heading3">
              {{ $t("pageCheckout.notorderincart") }}
            </h4>
          </el-col>
        </el-row>
      </el-col>

      <!-- Total Price -->
      <el-col
        v-bind:class="
          BranchDetail && UserLoginStatus
            ? 'px-4 pb-2 grey-border-bottom'
            : 'px-4 pb-2'
        "
      >
        <!-- รวม -->
        <el-row class="pb-2">
          <el-col :span="12">
            <label class="text-heading3 cl-gray-ligth">{{
              $t("pageCheckout.subtotal")
            }}</label>
          </el-col>
          <el-col :span="12">
            <label class="text-heading3 float-right"
              >{{ SubTotalAmount | priceFormat(roundingType,currency) }}</label
            >
          </el-col>
        </el-row>
        <!-- ค่าจัดส่ง -->
        <el-row class="pb-2" v-if="orderType && TotalCartPrice > 0">
          <!-- ซ้าย -->
          <el-col :span="11">
            <label class="text-heading3 cl-gray-ligth"
              >{{ $t("suggestion.delivery") }} ({{ distance }} km.)</label
            >
          </el-col>
          <!-- ขวา -->
          <el-col
            :span="13"
            v-if="
              (orderType &&
                SuggestionDetail &&
                distanceStatus == 'normal' &&
                deliveryFee > 0 &&
                SuggestionDetail.distanceOverFlag &&
                SuggestionDetail.freeFlag &&
                SuggestionDetail.overDetail.normalDeliveryFee != deliveryFee) ||
              (orderType &&
                SuggestionDetail &&
                distanceStatus == 'normal' &&
                deliveryFee > 0 &&
                SuggestionDetail.distanceOverFlag &&
                !SuggestionDetail.freeFlag &&
                SuggestionDetail.overDetail.normalDeliveryFee != deliveryFee)
            "
          >
            <label class="float-right text-heading3" v-if="deliveryFee == 0">{{
              $t("pageCheckout.free")
            }}</label>
            <label class="text-heading3 float-right" v-else
              >{{ SuggestionDetail.overDetail.normalDeliveryFee | priceFormat(0,currency) }}</label
            >
          </el-col>
          <el-col
            :span="13"
            v-else-if="orderType && distanceStatus == 'minimum'"
          >
            <label class="text-heading3 float-right"
              >{{ $t("pageCheckout.minimumorder") }} {{ minimum | priceFormat(0,currency) }}
              </label
            >
          </el-col>
          <el-col :span="13" v-else-if="orderType && distanceStatus == 'over'">
            <label class="text-heading3 float-right"
              >{{ $t("pageCheckout.maxdelivery") }} {{ minimum }} km.</label
            >
          </el-col>
          <el-col :span="13" v-else>
            <label class="float-right text-heading3" v-if="deliveryFee == 0">{{
              $t("pageCheckout.free")
            }}</label>
            <label class="text-heading3 float-right" v-else
              >{{ deliveryFee | priceFormat(0,currency) }}</label
            >
          </el-col>
        </el-row>
        <!-- ส่วนลด -->
        <el-row
          class="pb-2"
          v-if="
            (orderType &&
              SuggestionDetail &&
              distanceStatus == 'normal' &&
              deliveryFee > 0 &&
              SuggestionDetail.distanceOverFlag &&
              SuggestionDetail.freeFlag &&
              SuggestionDetail.overDetail.normalDeliveryFee != deliveryFee) ||
            (orderType &&
              SuggestionDetail &&
              distanceStatus == 'normal' &&
              deliveryFee > 0 &&
              SuggestionDetail.distanceOverFlag &&
              !SuggestionDetail.freeFlag &&
              SuggestionDetail.overDetail.normalDeliveryFee != deliveryFee)
          "
        >
          <el-col :span="12">
            <label class="text-heading3 cl-gray-ligth">{{
              $t("suggestion.discount")
            }}</label>
          </el-col>
          <el-col :span="12">
            <label class="text-heading3 float-right font-red"
              >-{{ SuggestionDetail.feeAmt | priceFormat(roundingType,currency) }}
            </label>
          </el-col>
        </el-row>
        <!-- Vat -->
        <el-row
          v-if="BranchDetail.taxType == 'Exclude' && BranchDetail.tax != '0.00'"
          class="pb-2"
        >
          <el-col :span="12">
            <label class="text-heading3 cl-gray-ligth"
              >Vat ({{ BranchDetail.tax | priceFormat }}%)</label
            >
          </el-col>
          <el-col :span="12">
            <label class="text-heading3 float-right"
              >{{ TaxAmount | priceFormat(roundingType,currency) }}
            </label>
          </el-col>
        </el-row>
        <!-- ราคารวม -->
        <el-row class="pb-2">
          <el-col :span="12">
            <label class="text-heading--bold">{{
              $t("pageCheckout.totalAmount")
            }}</label>
          </el-col>
          <el-col :span="12">
            <el-row
              v-if="
                orderType &&
                SuggestionDetail &&
                distanceStatus == 'normal' &&
                TotalCartPrice > 0
              "
            >
              <label
                class="text-heading--bold float-right"
                v-if="
                  SuggestionDetail.feeAmt == 0 ||
                  SuggestionDetail.totalFree == 0
                "
                >{{ TotalCartPrice | priceFormat(roundingType,currency) }}
              </label>
              <label
                class="text-heading--bold float-right"
                v-else-if="
                  TotalCartPrice < SuggestionDetail.totalFree &&
                  SuggestionDetail.distanceOverFlag &&
                  SuggestionDetail.freeFlag
                "
                >{{
                  (TotalCartPrice + deliveryFee) | priceFormat(roundingType,currency)
                }}
              </label>
              <label
                class="text-heading--bold float-right"
                v-else-if="
                  TotalCartPrice < SuggestionDetail.totalFree &&
                  SuggestionDetail.distanceOverFlag &&
                  !SuggestionDetail.freeFlag
                "
                >{{
                  (TotalCartPrice + deliveryFee) | priceFormat(roundingType,currency)
                }}
              </label>
              <label
                class="text-heading--bold float-right"
                v-else-if="
                  TotalCartPrice < SuggestionDetail.totalFree &&
                  !SuggestionDetail.distanceOverFlag &&
                  !SuggestionDetail.freeFlag
                "
                >{{
                  (TotalCartPrice + deliveryFee) | priceFormat(roundingType,currency)
                }}
              </label>
              <label
                class="text-heading--bold float-right"
                v-else-if="
                  TotalCartPrice >= SuggestionDetail.totalFree &&
                  !SuggestionDetail.distanceOverFlag &&
                  !SuggestionDetail.freeFlag
                "
                >{{ TotalCartPrice | priceFormat(roundingType,currency) }}
              </label>
              <label
                class="text-heading--bold float-right"
                v-else-if="
                  TotalCartPrice >= SuggestionDetail.totalFree &&
                  SuggestionDetail.distanceOverFlag &&
                  !SuggestionDetail.freeFlag
                "
                >{{
                  (TotalCartPrice + deliveryFee) | priceFormat(roundingType,currency)
                }}
              </label>
              <label
                class="text-heading--bold float-right"
                v-else-if="
                  TotalCartPrice >= SuggestionDetail.totalFree &&
                  SuggestionDetail.distanceOverFlag &&
                  SuggestionDetail.freeFlag
                "
                >{{ TotalCartPrice | priceFormat(roundingType,currency) }}
              </label>
              <div
                v-if="
                  (deliveryFee > 0 &&
                    SuggestionDetail.distanceOverFlag &&
                    SuggestionDetail.freeFlag &&
                    SuggestionDetail.overDetail.normalDeliveryFee !=
                      deliveryFee) ||
                  (deliveryFee > 0 &&
                    SuggestionDetail.distanceOverFlag &&
                    !SuggestionDetail.freeFlag &&
                    SuggestionDetail.overDetail.normalDeliveryFee !=
                      deliveryFee)
                "
                class="mt-2 fw-xs fs-14 fs-t-th fs-p-r float-right"
              >
              {{
                  (TotalCartPrice +
                    SuggestionDetail.overDetail.normalDeliveryFee)
                    | priceFormat(roundingType,currency)
                }}
              </div>
            </el-row>
            <el-row
              v-else-if="
                orderType &&
                SuggestionDetail === null &&
                distanceStatus == 'normal' &&
                TotalCartPrice > 0
              "
            >
              <label class="text-heading--bold float-right"
                >{{
                  (TotalCartPrice + deliveryFee) | priceFormat(roundingType,currency)
                }}
              </label>
            </el-row>
            <el-row v-else>
              <label class="text-heading--bold float-right"
                >{{ TotalCartPrice | priceFormat(roundingType,currency) }}
              </label>
            </el-row>
          </el-col>
        </el-row>
      </el-col>

      <!-- Payment Type -->
      <el-col :span="24" class="p-15" v-if="BranchDetail && UserLoginStatus">
        <div id="payment-type" class="text-left">
          <label class="text-title--large">{{ $t("pageCheckout.payment") }}</label>
          <!-- Have Bank Transfer -->
          <div class="py-2" v-if="BranchDetail.paymentBank.length > 0">
            <el-radio-group
              v-model="PaymentType"
              v-for="(payment, index) in PaymentResponse"
              :key="index"
            >
              <!-- COD -->
              <el-radio
                :label="'cod'"
                v-if="
                  BranchDetail.paymentCash &&
                  index === 0 &&
                  PreOrderTime.length == 0
                "
                id="pay-1"
              >
                <el-row class="width-100p">
                  <el-col :span="3">
                    <img
                      class="mt-2"
                      width="20"
                      src="@/assets/icons/thank/cash.png"
                    />
                  </el-col>
                  <el-col :span="21" class="bank_name text-subtitle">
                    {{ $t("pageCheckout.cod") }}
                  </el-col>
                </el-row>
              </el-radio>
              <!-- QR -->
              <el-radio
                :label="'qr'"
                v-else-if="BranchDetail.paymentQR && index === 1"
              >
                <el-row class="width-100p">
                  <el-col :span="3">
                    <img
                      class="mt-2"
                      width="20"
                      src="@/assets/icons/thank/icon-promptpay.png"
                    />
                  </el-col>
                  <el-col :span="21" class="bank_name text-subtitle">
                    {{ $t("pageCheckout.qr") }}
                  </el-col>
                </el-row>
              </el-radio>
              <!-- Credit Card -->
              <el-radio
                :label="'creditcard'"
                v-else-if="BranchDetail.paymentCreditCard && index === 2"
              >
                <el-collapse class="bank-collapse" v-if="UserCardList">
                  <el-collapse-item>
                    <template slot="title">
                      <el-row class="width-100p">
                        <el-col :span="9">
                          <img
                            class="mt-1"
                            width="100"
                            src="@/assets/icons/thank/creditcard.png"
                          />
                        </el-col>
                        <el-col :span="15" class="bank_name text-subtitle">
                          {{ $t("pageCheckout.credit") }}
                        </el-col>
                      </el-row>
                    </template>
                    <el-row class="pr-2 pb-2 mb-2 fs-bd-b">
                      <el-col
                        @click.native="selectCard(card)"
                        v-for="(card, idx) in UserCardList"
                        :key="idx"
                      >
                        <el-row class="pb-2">
                          <el-col :span="5">
                            <img
                              class="fs-credit-icon"
                              :src="'https://images.foodstory.co/' + card.img"
                            />
                          </el-col>
                          <el-col :span="15">
                            <label class="fw-md fs-14"
                              >**** {{ card.number }}</label
                            >
                          </el-col>
                          <el-col :span="4" class="text-left">
                            <i
                              v-show="idx == 0 ? true : false"
                              :id="card.uid"
                              class="fs-20 fs-link fs-al-b el-icon-success"
                            ></i>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <!-- <el-row v-if="distanceStatus == 'normal' && orderType">
                      <el-col @click.native="payNewCreditCard" class="d-flex align-center">
                        <i
                          class="fs-20 fs-link el-icon-circle-plus-outline"
                        ></i>
                        <label class="text-subtitle fs-al-b fs-link ml--1">{{
                          $t("pageCheckout.creditother")
                        }}</label>
                      </el-col>
                    </el-row>
                    <el-row v-if="distanceStatus == 'normal' && !orderType">
                      <el-col @click.native="payNewCreditCard" class="d-flex align-center">
                        <i
                          class="fs-20 fs-link el-icon-circle-plus-outline"
                        ></i>
                        <label class="text-subtitle fs-al-b fs-link ml--1">{{
                          $t("pageCheckout.creditother")
                        }}</label>
                      </el-col>
                    </el-row>
                    <el-row v-if="distanceStatus == '' && !orderType">
                      <el-col @click.native="payNewCreditCard" class="d-flex align-center">
                        <i
                          class="fs-20 fs-link el-icon-circle-plus-outline"
                        ></i>
                        <label class="text-subtitle fs-al-b fs-link ml--1">{{
                          $t("pageCheckout.creditother")
                        }}</label>
                      </el-col>
                    </el-row> -->
                    <el-row>
                      <el-col @click.native="payNewCreditCard" class="d-flex align-center">
                        <i class="mb--1 fs-20 fs-link el-icon-circle-plus-outline" />
                        <label class="text-subtitle fs-al-b fs-link ml--1">{{
                          $t("pageCheckout.creditother")
                        }}</label>
                      </el-col>
                    </el-row>
                  </el-collapse-item>
                </el-collapse>
                <el-row class="width-100p" v-else>
                  <el-col :span="8">
                    <img
                      class="mt-1"
                      width="100"
                      src="@/assets/icons/thank/creditcard.png"
                    />
                  </el-col>
                  <el-col :span="16" class="bank_name text-subtitle">
                    {{ $t("pageCheckout.credit") }}
                  </el-col>
                </el-row>
              </el-radio>
              <!-- Bank Transfer -->
              <el-radio :label="'bank' + index" v-else-if="index > 2">
                <el-row
                  v-if="
                    (!orderType && isSoldOut > 0 && TotalCartPrice > 0) ||
                    (orderType &&
                      (distanceStatus != 'normal' ||
                        !selectedAddress ||
                        isSoldOut > 0)) ||
                    TotalCartPrice == 0
                  "
                  class="width-100p"
                >
                  <el-col :span="3">
                    <img
                      width="20"
                      class="mt-1"
                      :src="'https://images.foodstory.co/' + payment.image_key"
                    />
                  </el-col>
                  <el-col :span="21" class="bank_name text-subtitle">
                    {{ payment.bank_name }}
                  </el-col>
                </el-row>
                <el-collapse
                  v-else-if="
                    (!orderType && isSoldOut == 0 && TotalCartPrice > 0) ||
                    (distanceStatus == 'normal' &&
                      isSoldOut == 0 &&
                      selectedAddress)
                  "
                  class="bank-collapse"
                >
                  <el-collapse-item>
                    <template slot="title">
                      <el-row class="width-100p">
                        <el-col :span="3">
                          <img
                            width="20"
                            class="mt-1"
                            :src="
                              'https://images.foodstory.co/' + payment.image_key
                            "
                          />
                        </el-col>
                        <el-col :span="21" class="bank_name text-subtitle">
                          {{ payment.bank_name }}
                        </el-col>
                      </el-row>
                    </template>
                    <el-row>
                      <el-col :span="18">
                        <span class="pay-detail text-subtitle"
                          >{{ $t("pageCheckout.accountname") }}:
                          {{ payment.account_name }}
                        </span>
                        <br />
                        <span class="pay-detail text-subtitle"
                          >{{ $t("pageCheckout.accountnumber") }}:
                          {{ payment.account_number }}
                        </span>
                      </el-col>
                      <el-col :span="6" class="">
                        <el-button
                          class="m-t-15 copy-btn text-button"
                          plain
                          @click="copyHandle(payment.account_number)"
                        >
                          {{ $t("pageCheckout.copy") }}
                        </el-button>
                      </el-col>
                    </el-row>
                  </el-collapse-item>
                </el-collapse>
              </el-radio>
            </el-radio-group>
          </div>
          <!-- Don't Have Bank Transfer -->
          <div class="py-2" v-else>
            <el-radio-group v-model="PaymentType">
              <!-- COD -->
              <el-radio
                :label="'cod'"
                v-show="BranchDetail.paymentCash && PreOrderTime.length == 0"
                id="pay-1"
              >
                <el-row class="width-100p">
                  <el-col :span="3">
                    <img
                      class="mt-2"
                      width="20"
                      src="@/assets/icons/thank/cash.png"
                    />
                  </el-col>
                  <el-col :span="21" class="bank_name text-subtitle">
                    {{ $t("pageCheckout.cod") }}
                  </el-col>
                </el-row> </el-radio
              ><br />
              <!-- QR -->
              <el-radio
                :label="'qr'"
                v-show="BranchDetail.paymentQR"
                id="pay-1"
              >
                <el-row class="width-100p">
                  <el-col :span="3">
                    <img
                      class="mt-2"
                      width="20"
                      src="@/assets/icons/thank/icon-promptpay.png"
                    />
                  </el-col>
                  <el-col :span="21" class="bank_name text-subtitle">
                    {{ $t("pageCheckout.qr") }}
                  </el-col>
                </el-row> </el-radio
              ><br />
              <!-- Credit Card -->
              <el-radio
                :label="'creditcard'"
                v-show="BranchDetail.paymentCreditCard"
              >
                <el-collapse class="bank-collapse" v-if="UserCardList">
                  <el-collapse-item>
                    <template slot="title">
                      <el-row class="width-100p">
                        <el-col :span="9">
                          <img
                            class="mt-1"
                            width="100"
                            src="@/assets/icons/thank/creditcard.png"
                          />
                        </el-col>
                        <el-col :span="15" class="bank_name text-subtitle">
                          {{ $t("pageCheckout.credit") }}
                        </el-col>
                      </el-row>
                    </template>
                    <el-row class="pr-2 pb-2 mb-2 fs-bd-b">
                      <el-col
                        @click.native="selectCard(card)"
                        v-for="(card, idx) in UserCardList"
                        :key="idx"
                      >
                        <el-row class="pb-2">
                          <el-col :span="5">
                            <img
                              class="fs-credit-icon"
                              :src="'https://images.foodstory.co/' + card.img"
                            />
                          </el-col>
                          <el-col :span="15">
                            <label class="fw-md fs-14"
                              >**** {{ card.number }}</label
                            >
                          </el-col>
                          <el-col :span="4" class="text-left">
                            <i
                              v-show="idx == 0 ? true : false"
                              :id="card.uid"
                              class="fs-20 fs-link fs-al-b el-icon-success"
                            ></i>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <el-row v-if="distanceStatus == 'normal' && orderType">
                      <el-col @click.native="payNewCreditCard">
                        <i
                          class="fs-20 fs-link el-icon-circle-plus-outline"
                        ></i>
                        <label class="text-subtitle fs-al-b fs-link">{{
                          $t("pageCheckout.creditother")
                        }}</label>
                      </el-col>
                    </el-row>
                    <el-row v-if="distanceStatus == 'normal' && !orderType">
                      <el-col @click.native="payNewCreditCard">
                        <i
                          class="fs-20 fs-link el-icon-circle-plus-outline"
                        ></i>
                        <label class="text-subtitle fs-al-b fs-link">{{
                          $t("pageCheckout.creditother")
                        }}</label>
                      </el-col>
                    </el-row>
                    <el-row v-if="distanceStatus == '' && !orderType">
                      <el-col @click.native="payNewCreditCard">
                        <i
                          class="fs-20 fs-link el-icon-circle-plus-outline"
                        ></i>
                        <label class="text-subtitle fs-al-b fs-link">{{
                          $t("pageCheckout.creditother")
                        }}</label>
                      </el-col>
                    </el-row>
                  </el-collapse-item>
                </el-collapse>
                <el-row class="width-100p" v-else>
                  <el-col :span="8">
                    <img
                      class="mt-1"
                      width="100"
                      src="@/assets/icons/thank/creditcard.png"
                    />
                  </el-col>
                  <el-col :span="16" class="bank_name text-subtitle">
                    {{ $t("pageCheckout.credit") }}
                  </el-col>
                </el-row>
              </el-radio>
            </el-radio-group>
          </div>
        </div>
      </el-col>

      <!-- Footer Button -->
      <el-col :span="24" class="fs-footer-cart" v-if="BranchDetail">
        <el-row>
          <!-- pick up -->
          <!-- After User Login -->
          <el-col class="px-10 pt-4" v-if="!orderType">
            <fullButton
              v-if="$store.getters.AmountCart.length > 0 && UserLoginStatus"
              :frompage="'cart'"
              :badge="badge"
              :totalprice="
                orderType ? TotalCartPrice + deliveryFee : TotalCartPrice
              "
              :display="isSoldOut > 0 ? true : displayConfirmOrder"
              :handleClick="routeToConfirmOrder"
              :btn_text="$t('pageCheckout.confirmOrder')"
            />
          </el-col>
          <!-- Befor User Login -->
          <el-col v-if="!orderType">
            <fullButton
              :display="isSoldOut > 0 ? true : displayConfirmOrder"
              v-if="$store.getters.AmountCart.length > 0 && !UserLoginStatus "
              :handleClick="routeToCheckLogin"
              :btn_text="$t('pageCheckout.Inprogress')"
            />
          </el-col>
          <!-- delivery -->
          <el-col class="px-10 pt-2" v-else>
            <!-- สั่งเพิ่ม -->
            <el-row
              class="pb-2"
              v-if="
                SuggestionDetail &&
                orderType &&
                TotalCartPrice < SuggestionDetail.totalFree
              "
            >
              <label
                class="text-subtitle"
                v-if="
                  SuggestionDetail.distanceOverFlag &&
                  SuggestionDetail.feeAmt != 0 &&
                  SuggestionDetail.totalFree != 0 &&
                  SuggestionDetail.freeFlag
                "
                >{{ $t("suggestion.addorder") }}
                <b class="fw-md"
                  >{{
                    (SuggestionDetail.totalFree - TotalCartPrice) | priceFormat(roundingType,currency)
                  }}</b
                >
                {{ $t("suggestion.text1") }}
                <em class="fw-md fs-st-n font-green">{{
                  $t("suggestion.deliveryFee")
                }}</em></label
              >
              <label
                class="text-subtitle"
                v-else-if="
                  SuggestionDetail.distanceOverFlag &&
                  SuggestionDetail.feeAmt != 0 &&
                  SuggestionDetail.totalFree != 0 &&
                  !SuggestionDetail.freeFlag
                "
                >{{ $t("suggestion.addorder") }}
                <b class="fw-md"
                  >{{
                    (SuggestionDetail.totalFree - TotalCartPrice) | priceFormat(roundingType,currency)
                  }}</b
                >
                {{ $t("suggestion.text1") }}
                <em class="fw-md fs-st-n font-green"
                  >{{ $t("suggestion.discount") }}
                  {{ $t("suggestion.delivery") }} {{
                    SuggestionDetail.feeAmt | priceFormat(roundingType,currency)
                  }}</em
                ></label
              >
              <label class="text-subtitle" v-else-if="deliveryFee != 0"
                >{{ $t("suggestion.addorder") }}
                <b class="fw-md"
                  >{{
                    (SuggestionDetail.totalFree - TotalCartPrice) | priceFormat(roundingType,currency)
                  }}</b
                >
                {{ $t("suggestion.text2") }}
                <em class="fw-md fs-st-n font-green">{{
                  $t("suggestion.deliveryFee")
                }}</em></label
              >
            </el-row>
            <fullButton
              v-if="$store.getters.AmountCart.length > 0 && UserLoginStatus"
              :frompage="'cart'"
              :badge="badge"
              :totalprice="
                orderType ? TotalCartPrice + deliveryFee : TotalCartPrice
              "
              :display="
                !(isSoldOut > 0) || !selectedAddress
                  ? displayConfirmOrder
                  : !displayConfirmOrder
              "
              :handleClick="routeToConfirmOrder"
              :btn_text="$t('pageCheckout.confirmOrder')"
            />
            <fullButton
              v-if="$store.getters.AmountCart.length > 0 && !UserLoginStatus "
              :frompage="'cart'"
              :badge="badge"
              :totalprice="
                orderType ? TotalCartPrice + deliveryFee : TotalCartPrice
              "
              :display="isSoldOut > 0 ? true : displayConfirmOrder"
              :handleClick="routeToCheckLogin"
              :btn_text="$t('pageCheckout.Inprogress')"
            />
          </el-col>
        </el-row>
      </el-col>

      <!-- Drawer Preorder -->
      <DrawerPreorderTime
        v-if="is_preorder"
        @toogle_preorder="toogle_preorder_time"
      />
      <!-- Drawer Map -->
      <!-- <MapDrawer
        v-show="BranchDetail.deliveryFlag === '1'" 
        v-if="is_map" 
        :is_search="is_map"
        @toggle_search="toggle_map"
        @distance_info="setDistanceInfo" 
      /> -->

      <LocationSelectionDrawer
        v-model="is_map"
        :location="selectedLocation || branchLocation"
        @submit="onSelectLocation"
      />

      <!-- Drawer Credit Card -->
      <DrawerCreditCard
        v-if="is_creditcard && $store.getters.AmountCart.length > 0"
        :disablePayCredit="isSoldOut > 0 ? true : disablePayCredit"
        :orderType="orderType"
        :TotalCartPrice="TotalCartPrice"
        :deliveryFee="deliveryFee"
        :AmountCart="AmountCart"
        :is_credit="is_creditcard"
        @toggle_creditcard="toggle_credit"
        @validate_creditcard="validateCreditCard"
      />
      <!-- Dialog Confirm -->
      <DialogConfirm />
    </el-row>
    <!-- Dialog Minimum Price And Dialog Over Distance | orderType : false = pickup -->
    <Dialog
      v-if="isOpenDialog"
      @toggleDialog="toggleDialog"
      :dialogConfirm="true"
      :dialogTitle="dialogTitle"
      :dialogText="dialogText"
      :dialogSrc="dialogSrc"
      :dialogRedirect="dialogRedirect"
      :btnText="dialogBtn"
    />
  </div>
</template>
<script>
import LineLiff from '@line/liff'

import elementCheckout from "@/components/element/elementCheckout";
import fullButton from "@/components/element/fullButton";
import Dialog from "@/components/dialog/Dialog";
import DialogConfirm from "@/components/dialog/DialogConfirm";
import DrawerCreditCard from "@/components/creditcard/DrawerCreditCard";
import DrawerPreorderTime from "@/components/preorder/DrawerPreorderTime";
import Gmap from "@/components/element/Gmap";

import MapDrawer from "@/components/map/MapDrawer";
import LocationSelectionDrawer from "@/components/locationselection/LocationSelectionDrawer.vue";
import Mixins from "@/utils/mixins";

export default {
  name: "CheckoutCart",
  props: ["restaurant_uuid", "branch_uuid"],
  mixins: [Mixins],
  components: {
    elementCheckout,
    fullButton,
    MapDrawer,
    Dialog,
    DialogConfirm,
    DrawerCreditCard,
    DrawerPreorderTime,
    LocationSelectionDrawer,
    Gmap,
  },
  data() {
    return {
      UserLoginStatus: false,
      AddAddress: "",
      PaymentType: "",
      orderType: true,
      InputDeliveryNote: "",
      InputPickupNote: "",
      Menus: [],
      OptionGroups: [],
      option: [],
      // restaurantId: null,
      lat: "",
      lng: "",
      is_map: false,
      is_search: false,
      is_credit: false,
      is_creditcard: false,
      is_preorder: false,
      disablePayCredit: true,
      deliveryFee: 0,
      distance: 0,
      distanceStatus: "",
      minimum: 0,
      isOpenDialog: false,
      dialogTitle: "",
      dialogText: "",
      dialogSrc: "",
      dialogRedirect: [],
      dialogBtn: "",
      isCopy: false,
      CardUID: "",
      displayConfirmOrder: false,
      PreOrderTime: [],
      badge: 0,
      Objoption: [],
      updateOutOfStock: "",
      outOfStock:false,
      isSoldOut: 0,
      isOptionSoldOut:0,
      selectedLocation: null,
      currency: this.$store.getters.currency
    };
  },
  mounted() {
    // console.log('mouted checkout')
    // this.is_creditcard = true

    // Set Top Page
    window.scrollTo(0, 0);

    // Set Pickup Note & Delivery Note
    this.InputDeliveryNote = this.DeliveryNote;
    this.InputPickupNote = this.PickupNote;

    // Check User Login
    if (this.UserLogin === null) {
      // Recheck User Login
      this.$store.dispatch("onAuthStateChanged").then((user) => {
        this.UserLoginStatus = user;
        if (user) {
          this.stampLineLogin();
          this.$store.dispatch("getUserInfo");
          this.$store.dispatch("getUserCardList");
          this.$store.dispatch("getDeliveryTime", {
            branches: this.BranchDetail.id,
          });
        }
      });
    } else {
      if (this.UserLogin) {
        this.stampLineLogin();
        this.$store.dispatch("getUserInfo");
        this.$store.dispatch("getUserCardList");
        this.$store.dispatch("getDeliveryTime", {
          branches: this.BranchDetail.id,
        });
      }
      this.UserLoginStatus = this.UserLogin;
    }

    // Get Send Order By BranchId From Local Storage
    let receive = JSON.parse(
      localStorage.getItem("send-" + this.BranchDetail.id)
    );
    if (receive == "delivery") {
      this.orderType = true;
    } else {
      this.orderType = false;
    }

    const userLocation = JSON.parse(localStorage.getItem('fsloc') || '{}')
	  const hasLocation = Number.isFinite(userLocation.lat) && Number.isFinite(userLocation.lng)
    if (hasLocation) {
      this.selectedLocation = userLocation;
    }
    // Get API deliveryfee When DistanceMatrix Not NULL
    if (this.DistanceInfo !== null) {
      this.$store
        .dispatch("getDistanceInfo", {
          distance: this.DistanceInfo.dis_metre * 1000,
          total: this.TotalCartPrice,
          location: this.selectedLocation,
          restaurant: this.BranchDetail.restaurantId,
          branch: this.BranchDetail.id,
        })
        .then((response) => {
          if (typeof response != "undefined") {
            this.distanceStatus = response.status;
            this.checkStatus(response)
          }
        });
    }
  },
  methods: {
    checkStatus(response){
      if (response.status === "over" && this.orderType) {
        if (this.TotalCartPrice > 0 ) {
          this.setDialogOverDistance();
        }
        this.distance = response.dis_metre;
        this.minimum = response.price;
        this.deliveryFee = 0;
        this.displayConfirmOrder = true
      } else if (response.status === "minimum" && this.orderType) {
        if (this.TotalCartPrice > 0) {
          this.setDialogMinimumPrice(response.price);
        }
        this.distance = response.dis_metre;
        this.minimum = response.price;
        this.deliveryFee = 0;
        this.displayConfirmOrder = true
      } else {
        this.displayConfirmOrder = false
        this.deliveryFee = response.price;
        this.distance = response.dis_metre;
      }
    },
    onSelectLocation: async function ({ location, done }) {
      try {
        this.selectedLocation = Object.assign(
          {},
          this.selectedLocation,
          location
        );
        this.checkDupLocation();
        localStorage.setItem("fsloc", JSON.stringify(this.selectedLocation));
        const updatedLocation = JSON.parse(localStorage.getItem("fsloc"));
        const distanceInfo = await this.updateDistanceInfo(updatedLocation);
        await this.setDistanceInfo(distanceInfo);
      } finally {
        done(true);
      }
    },
    checkDupLocation() {
      const locationFromStore = JSON.parse(localStorage.getItem("fsloc"));
      const isOldLocation =
        locationFromStore &&
        locationFromStore.lat == this.selectedLocation.lat &&
        locationFromStore.lng == this.selectedLocation.lng;
      if (isOldLocation) {
        this.selectedLocation.new = 0;
      } else {
        this.selectedLocation.new = 1;
      }
      return this.$store.dispatch("setChangeLocation", {
        status: this.selectedLocation.new == 0 ? "old" : "first",
        branch: this.BranchDetail,
        location: this.selectedLocation,
      });
    },
    updateDistanceInfo: async function (fromLocation) {
      if (!fromLocation) return;
      const distance = await this.$store.dispatch("calculateDistance", {
        origin_coordinates: [
          this.BranchDetail.latitude,
          this.BranchDetail.longitude,
        ],
        origin_address: this.BranchDetail.address,
        destination_address: fromLocation.address,
        destination_coordinates: [fromLocation.lat, fromLocation.lng],
      });
      const distanceInfo = await this.$store.dispatch("getDistanceInfo", {
        distance,
        total: this.TotalCartPrice,
        location: fromLocation,
        restaurant: this.BranchDetail.restaurantId,
        branch: this.BranchDetail.id,
      });
      return distanceInfo;
    },
    stampLineLogin() {
      if (this.BranchDetail !== null) {
        const liffId = this.BranchDetail.liffId;
        if (liffId != "") {
          var UA = navigator.userAgent || navigator.vendor || window.opera;
          var isLINE = function (UA) {
            return UA.indexOf("Line/") > -1;
          };
          // alert('browser line: ' + isLINE(UA) + ' browser line: ' + LineLiff.isInClient())
          if (isLINE(UA)) {
            if (LineLiff.isLoggedIn()) {
              LineLiff.getProfile().then((profile) => {
                // if (this.UserInfo !== null && this.UserLineInfo === null) {
                this.$store.dispatch("recheckStampUserLine", {
                  profile: profile,
                  restaurant_uuid: this.BranchDetail.restaurantId,
                });
                // }
              });
            } else {
              LineLiff.login();
            }
          }
        }
      }
    },
    toggleDialog(action) {
      if (action == "ismap") {
        this.is_map = true;
      }
      // else if (action == 'pickup') {
      //   if (this.BranchDetail.pickupFlag == '1') {
      //     this.orderType = false
      //     localStorage.setItem('send-' + this.BranchDetail.id, JSON.stringify('pick-up'))
      //   }
      // }
      this.isOpenDialog = !this.isOpenDialog;
    },
    toggle_map() {
      this.is_map = !this.is_map;
    },
    toggle_credit() {
      this.is_creditcard = !this.is_creditcard;
    },
    toogle_preorder_time(datetime) {
      // Payment COD And Case Preorder
      if (this.PaymentType == "cod" && datetime.length > 0) {
        this.PaymentType = "";
      }
      this.PreOrderTime = datetime.length > 0 ? datetime : [];
      this.is_preorder = !this.is_preorder;
    },
    copyHandle(str) {
      const el = document.createElement("textarea"); // Create a <textarea> element
      el.value = str; // Set its value to the string that you want copied
      el.setAttribute("readonly", ""); // Make it readonly to be tamper-proof
      el.style.position = "absolute";
      el.style.left = "-9999px"; // Move outside the screen to make it invisible
      document.body.appendChild(el); // Append the <textarea> element to the HTML document
      const selected =
        document.getSelection().rangeCount > 0 // Check if there is any content selected previously
          ? document.getSelection().getRangeAt(0) // Store selection if found
          : false; // Mark as false to know no selection existed before
      el.select(); // Select the <textarea> content
      document.execCommand("copy"); // Copy - only works as a result of a user action (e.g. click events)
      document.body.removeChild(el); // Remove the <textarea> element
      if (selected) {
        // If a selection existed before copying
        document.getSelection().removeAllRanges(); // Unselect everything on the HTML document
        document.getSelection().addRange(selected); // Restore the original selection
      }
      if (!this.isCopy) {
        this.$notify({
          title: this.$t("pageCheckout.copyaccount"),
          customClass: "copy-notify",
          iconClass: "copy-notification",
          duration: 4000,
          type: "success",
          showClose: false,
        });
        this.isCopy = true;
        setTimeout(() => {
          this.isCopy = false;
        }, 4000);
      }
    },
    setDistanceInfo(distance) {
      // Return distance From Map Drawer
      this.distanceStatus = distance.status;
      this.checkStatus(distance)
    },
    setDialogMinimumPrice(minimumPrice) {
      // console.log(this.DialogMinimumPrice)
      // if (!this.DialogMinimumPrice) {
        this.toggleDialog();
        this.isOpenDialog = true;
        this.dialogTitle = this.$t("dialog.minimumprice.title");
        this.dialogText = `${this.$t(
          "dialog.minimumprice.text1"
        )}${this.price_format(minimumPrice,this.currency)} ${this.$t(
          "dialog.minimumprice.text2"
        )}${this.price_format(minimumPrice - this.TotalCartPrice,this.currency)} ${this.$t(
          "dialog.minimumprice.text3"
        )}`;
        this.dialogSrc = "icons/minimum-price.png";
        this.dialogRedirect = [
          true,
          "/restaurant/" + this.restaurant_uuid + "/" + this.branch_uuid,
        ];
        this.dialogBtn = `${this.$t("dialog.minimumprice.ordermore")}`;
        this.$store.dispatch("setDialogMinimumPrice", true);
      // }
    },
    setDialogOverDistance() {
      const isDeliverySelected = this.orderType
      if (!isDeliverySelected) return
      // console.log(this.DialogMinimumPrice)
      // if (!this.DialogMinimumPrice) {
      this.toggleDialog();
      this.isOpenDialog = true;
      this.dialogTitle = this.$t("dialog.overdistance.title");
      this.dialogText = this.$t("dialog.overdistance.text");
      this.dialogSrc = "icons/over-distance.png";
      this.dialogRedirect = [true, "overdistance"];
      this.dialogBtn = this.$t("dialog.overdistance.searchmore");
      this.$store.dispatch("setDialogOverDistance", true);
      // }
    },
    generateDateTime() {
      if (this.PreOrderTime.length == 0) {
        return this.convertDateTime();
      } else {
        return this.PreOrderTime[1];
      }
    },
    deleteMenuInCart(menu, index) {
      this.isSoldOut--;
      this.$store.dispatch("deleteMenuInCart", {
        index: index,
        menu: menu,
        branchdetail: this.BranchDetail,
      });
    },
    deleteSoldOutInCart() {
        this.$store.dispatch("deleteSoldOutInCart", {
        menu: this.AmountCart,
        branchdetail: this.BranchDetail,
      });
    },
    editMenuDetail(menu, index) {
      this.$router.push({
        name: "MenuDetail",
        params: {
          restaurant_uuid: this.restaurant_uuid,
          branch_uuid: this.branch_uuid,
          menu_uuid: menu.id,
          menu,
        },
        query: { action: "editCart", number: index },
      });
      // this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/menu/${menu.id}`, query: { 'action': 'editCart', 'number': index } })
    },
    gomenu() {
      this.$router.push({
        path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}`,
      });
    },
    routeToCheckLogin() {
      if (this.UserLogin) {
        this.$router.go({
          path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/checkout`,
        });
      } else {
        this.$router.push({
          path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/verify/phonenumber`,
        });
      }
    },
    redirectToMenu() {
      this.$router.push({
        path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}`,
      });
    },
    changePreorderTime() {
      this.is_preorder = true;
    },
    selectCard(card) {
      this.UserCardList.forEach((ele) => {
        if (card.uid == ele.uid) {
          this.CardUID = ele.uid;
          document.getElementById(ele.uid).style.display = "block";
        } else {
          document.getElementById(ele.uid).style.display = "none";
        }
      });
    },
    validateCreditCard(Datacreditcard) {
      this.disablePayCredit = true; // disable btn component DrawerCreditCard
      let OrderRequest = this.generateObjOrder(18, Datacreditcard);
      this.createOrder(OrderRequest);
    },
    payNewCreditCard() {
      this.PaymentType = "creditcard";
      this.is_creditcard = true;
    },
    routeToConfirmOrder() {
      this.displayConfirmOrder = true;
      if(this.TotalCartPrice < this.minimum && this.orderType)
        return this.setDialogMinimumPrice(this.minimum)

      const isUserLocationEmpty = !this.selectedLocation && this.orderType;
      if (isUserLocationEmpty) {
        return this.$alert(
          this.$t("alert.address.title"),
          this.$t("dialog.alert"),
          {
            confirmButtonText: this.$t("dialog.ok"),
            callback: () => {
              this.displayConfirmOrder = false;
              window.scrollTo(0, 0);
            },
          }
        );
      }

      const isDistanceOver = this.distanceStatus === "over" && this.orderType;
      if (isDistanceOver) return this.setDialogOverDistance();

      const isPaymentTypeEmpty = !this.PaymentType;
      if (isPaymentTypeEmpty) {
        return this.$alert(
          this.$t("alert.payment.title"),
          this.$t("dialog.alert"),
          {
            confirmButtonText: this.$t("dialog.ok"),
            callback: () => {
              this.displayConfirmOrder = false;
            },
          }
        );
      }

      this.sendOrderToPOS();
    },
    async sendOrderToPOS() {
      // const loading = this.$loading({
      //   lock: true,
      //   text: "Loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });

      this.$confirm(
        this.$t("alert.confirmorder.title1"),
        this.$t("alert.confirmorder.title2"),
        {
          closeOnPressEscape: false,
          closeOnClickModal: false,
          confirmButtonText: this.$t("dialog.yes"),
          cancelButtonText: this.$t("dialog.no"),
          type: "warning",
        }
      )
        .then(() => {
          if (this.PaymentType == "cod") {
            let OrderRequest = this.generateObjOrder(1);
            this.createOrder(OrderRequest);
          } else if (this.PaymentType == "qr") {
            let OrderRequest = this.generateObjOrder(17);
            this.createOrder(OrderRequest);
          } else if (this.PaymentType == "creditcard") {
            if (this.UserCardList.length < 1) {
              this.is_creditcard = true;
              // loading.close();
              this.displayConfirmOrder = false;
            } else {
              let OrderRequest = this.generateObjOrder(18, {
                uid:
                  this.CardUID == "" ? this.UserCardList[0].uid : this.CardUID,
                number: "",
                holder: "",
                month: "",
                year: "",
                cvv: "",
                new: "",
                save: "",
              });
              this.createOrder(OrderRequest);
            }
          } else {
            let OrderRequest = this.generateObjOrder(2);
            this.createOrder(OrderRequest);
          }
        })
        .catch((err) => {
          // loading.close();
          this.displayConfirmOrder = false;
          // this.$message({
          //   type: 'info',
          //   message: 'ยังไม่สั่งซื้อ'
          // })
        });
    },
    generateObjOrder(PaymentTypeId, Datacreditcard = null) {
      this.Menus = [];

      this.AmountCart.forEach((menu) => {
        menu.options.forEach((op, i) => {
          this.option.push({
            option_group_id: op.option_group_id,
            id: op.id,
            quantity: op.qty,
          });
        });

        var groupoption = _.mapValues(
          _.groupBy(this.option, "option_group_id"),
          (clist) => clist.map((op) => _.omit(op, "option_group_id"))
        );

        Object.keys(groupoption).forEach((element, index) => {
          this.OptionGroups.push({
            id: element,
            options: groupoption[element],
          });
        });

        this.Menus.push({
          id: menu.id,
          quantity: menu.qty,
          dontWantItems: [],
          note: menu.notaion,
          optionGroups: this.OptionGroups,
        });

        this.OptionGroups = [];
        this.option = [];
      });

      let OrderRequest = {};
      OrderRequest = {
        customer: {
          name: this.UserInfo.name,
          phone: this.UserInfo.phone,
        },
        orderType: this.orderType ? 3 : 2,
        deliveryInfo: {
          address: this.selectedLocation.address,
          addressNote: this.orderType
            ? this.InputDeliveryNote
            : this.InputPickupNote,
          destination: "",
          isDeliveryNow: true,
          isPreorder: this.PreOrderTime.length == 0 ? false : true,
          latitude: this.selectedLocation.lat,
          longitude: this.selectedLocation.lng,
          scheduleTime: this.generateDateTime(),
          deliveryFee: this.orderType ? this.deliveryFee : 0,
          distance: this.distance,
        },
        menus: this.Menus,
        payment: {
          type: PaymentTypeId,
          branch_bank_account_id:
            this.PaymentType == "cod" ||
            this.PaymentType == "qr" ||
            this.PaymentType == "creditcard"
              ? ""
              : this.PaymentResponse[this.PaymentType.substring(4)]
                  .branch_bank_account_id,
          cardId:
            this.PaymentType == "creditcard" ? Datacreditcard.uid.trim() : "",
          cardNo:
            this.PaymentType == "creditcard"
              ? Datacreditcard.number.trim()
              : "",
          expirationMonth:
            this.PaymentType == "creditcard" ? Datacreditcard.month.trim() : "",
          expirationYear:
            this.PaymentType == "creditcard" ? Datacreditcard.year.trim() : "",
          securityCode:
            this.PaymentType == "creditcard" ? Datacreditcard.cvv.trim() : "",
          cardName:
            this.PaymentType == "creditcard"
              ? Datacreditcard.holder.trim()
              : "",
          deviceId: "",
          isNewCard: this.PaymentType == "creditcard" ? Datacreditcard.new : "",
          isRemember:
            this.PaymentType == "creditcard" ? Datacreditcard.save : "",
        },
        fullTaxInvDetail: {
          phonePrefix: "",
          phone: "",
          countryCode: "",
          taxId: "",
          name: "",
          branch: "",
          address: "",
          email: "",
        },
      };
      return OrderRequest;
    },
    async createOrder(OrderRequest) {
      // console.log(OrderRequest)
      // const loading = this.$loading({
      //   lock: true,
      //   text: "Loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });
      const loading = await this.$store.dispatch('startLoading')
      this.$store
        .dispatch("sendOrderList", {
          order: OrderRequest,
          branches: this.BranchDetail.id,
          restaurants: this.BranchDetail.restaurantId,
        })
        .then((response) => {
          if (response.data.status && response.data.paymentType == 17) {
            this.$store.dispatch("clearCart");
            this.$store.dispatch("setCachePreorderTime", []);
            loading.close();
            this.$router.push({
              path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/qr`,
              query: {
                rcp: response.data.receiptNo,
                unq: response.data.uniqueOrderCode,
                uid: this.BranchDetail.id,
              },
            });
          } else if (!response.data.status && response.data.paymentType == 18) {
            loading.close();
            this.displayConfirmOrder = false; // enable btn confirm order
            this.disablePayCredit = false; // enable btn component DrawerCreditCard
            this.$store.commit("setConfirmDialog", [
              true,
              this.$t("dialog.payment.credit.title1"),
              "",
              "fs-error",
              "once",
            ]);
          } else {
            if (response.data.status) {
              this.$store.dispatch("clearCart");
              this.$store.dispatch("setCachePreorderTime", []);
              this.$router.push({
                path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/confirmorder`,
                query: { oid: response.data.orderId },
              });
              loading.close();
              this.displayConfirmOrder = false;
            } else {
              this.$alert(
                this.$t("alert.confirmorder.title3"),
                this.$t("dialog.alert"),
                {
                  confirmButtonText: this.$t("dialog.yes"),
                }
              );
              loading.close();
              this.$router.go(0);
            }
          }
        })
        .catch((err) => {
          this.$alert(
            this.$t("alert.confirmorder.title4"),
            this.$t("dialog.alert"),
            {
              confirmButtonText: this.$t("dialog.yes"),
            }
          );
          loading.close();
          this.$router.go(0);
        });
    },
    createInfoDistance(response) {
      if (typeof response != "undefined" || response !== null) {
        this.distanceStatus = response.status;
        this.checkStatus(response)
      }
    },
  },
  computed: {
    branchLocation: function () {
      const { latitude, longitude } = this.BranchDetail || {};
      const hasLocation = Number.isFinite(latitude) && Number.isFinite(longitude);
      const branchLocation = hasLocation ? { lat: latitude, lng: longitude } : {};
      return branchLocation
    },
    selectedAddress: function () {
      return this.selectedLocation && this.selectedLocation.address;
    },
    AmountCart() {
      this.badge = 0;
      this.isSoldOut = 0;
      this.isOptionSoldOut = 0;
      var amountCart = this.$store.getters.AmountCart;
      amountCart.forEach((element, i) => {
        // Recheck isSoldOut Menu
        this.$store.dispatch("getMenuDetail", {
            restaurant_uuid: this.BranchDetail.restaurantId,
            branch_uuid: this.BranchDetail.id,
            menu_uuid: element.id,
            }).then((response) => {
            if (
              typeof response.isSoldOut == "undefined" ||
              response.isSoldOut ||
              response.length == 0
            ) {
              // response.length == 0 recheck menu close delivery flag from tbl_menu
              this.isSoldOut += 1;
            }
              this.Objoption[i] = Object.assign(element, {
              is_sold_out: typeof response.isSoldOut == "undefined" ||
                response.isSoldOut ||
                response.length == 0 
              //ถ้าค่าออกมาหมด 
                  ? true
                  : response.isSoldOut,
            });
             response.optionGroups.forEach((x)=>
              {
                x.options.forEach((y)=>{
                  if(y.outOfStock == true)
                  {
                  this.updateOutOfStock = element.options.find(ele => ele.id == y.id)
                  if(this.updateOutOfStock != undefined)
                  {
                      this.Objoption[i] = Object.assign(element, {
                      is_sold_out: true
                        });
                        this.isSoldOut += 1
                  }
                  }
                })
              })  
          });
        
        this.badge += element.qty;
      });
      // console.log(amountCart);
      return amountCart;
    },
    SubTotalAmount() {
      return this.$store.getters.SubTotalAmount;
    },
    TaxAmount() {
      return this.$store.getters.TaxAmount;
    },
    TotalCartPrice() {
      let TotalCartPrice = this.$store.getters.TotalCartPrice;
      if (TotalCartPrice !== 0) {
        let location = JSON.parse(localStorage.getItem("fsloc"));
        if (location) {
          this.selectedLocation = location;
          // this.AddAddress = location.address
          // this.lat = location.lat
          // this.lng = location.lng

          // this.DistanceInfo -> API deliveryfee
          // this.SuggestionDetail -> API deliveryfee-suggestion
          // Get API Google Distance Matrix When DistanceInfo = NULL
          if (this.DistanceInfo === null) {
            this.$store.dispatch("setChangeLocation", {
              status: "old",
              branch: this.BranchDetail,
              location: this.selectedLocation,
            });

            this.updateDistanceInfo(this.selectedLocation).then(
              this.createInfoDistance
            );

            // this.$store.dispatch('calculateDistanceOSRM', {
            //   origin_coordinates: [this.BranchDetail.latitude, this.BranchDetail.longitude],
            //   origin_address: this.BranchDetail.address,
            //   destination_address: this.selectedLocation.address,
            //   destination_coordinates: [this.selectedLocation.lat, this.selectedLocation.lng]
            // }).then((distance) => {
            //   let noDistance = true
            //   if(distance !== null && distance !== undefined){
            //       noDistance = false
            //       this.$store.dispatch('getDistanceInfo', {
            //         distance: distance,
            //         total: this.TotalCartPrice,
            //         location: this.selectedLocation,
            //         restaurant: this.BranchDetail.restaurantId,
            //         branch: this.BranchDetail.id
            //       }).then( (response) => {
            //           this.createInfoDistance(response)
            //       })
            //   }
            //   if(noDistance){
            //      this.$store.dispatch('calculateDistanceMatrix', {
            //       origin_coordinates: [this.BranchDetail.latitude, this.BranchDetail.longitude],
            //       origin_address: this.BranchDetail.address,
            //       destination_address: this.AddAddress,
            //       destination_coordinates: [this.lat, this.lng]
            //     }).then( (distance) => {
            //        this.$store.dispatch('getDistanceInfo', {
            //         distance: distance,
            //         total: this.TotalCartPrice,
            //         location: { lat: this.lat, lng: this.lng, address: this.AddAddress },
            //         restaurant: this.BranchDetail.restaurantId,
            //         branch: this.BranchDetail.id
            //       }).then(  (response) => {
            //         this.createInfoDistance(response)
            //       })
            //     })
            //   }
            // })
          }
        }
      }
      return TotalCartPrice;
    },
    BranchDetail() {
      let branch = this.$store.getters.BranchDetail;
      if (branch.deliveryFlag !== "1" || branch.pickupFlag !== "1") {
        if (branch.deliveryFlag === "1") {
          localStorage.setItem("send-" + branch.id, JSON.stringify("delivery"));
        } else {
          localStorage.setItem("send-" + branch.id, JSON.stringify("pick-up"));
        }
      }
      return branch;
    },
    PreOrderDetail() {
      let preorder = this.$store.getters.PreOrderDetail;
      if (
        (preorder !== null &&
          preorder.deliveryTime.isOpen &&
          !preorder.orderNowSetting.orderNowFlag &&
          preorder.preOrderSetting.preorderFlag) ||
        (preorder !== null &&
          !preorder.deliveryTime.isOpen &&
          preorder.orderNowSetting.orderNowFlag &&
          preorder.preOrderSetting.preorderFlag) ||
        (preorder !== null &&
          !preorder.deliveryTime.isOpen &&
          !preorder.orderNowSetting.orderNowFlag &&
          preorder.preOrderSetting.preorderFlag)
      ) {
        // CASE 2,3,4 Phase 3.0
        if (this.PreOrderTime.length == 0 && this.UserLogin) {
          // Display First Time Only
          this.is_preorder = true;
        }
      }
      return preorder;
    },
    CachePreorderTime() {
      let CachePreorderTime = this.$store.getters.CachePreorderTime;
      if (CachePreorderTime.length > 0) {
        this.PreOrderTime = CachePreorderTime;
      }
      return CachePreorderTime;
    },
    menuPrice() {
      let price = this.$store.getters.AmountCart;
      return price.map((item) => item.subtotal);
    },
    UserLineInfo() {
      return this.$store.getters.UserLineInfo;
    },
    UserInfo() {
      return this.$store.getters.UserInfo;
    },
    UserLogin() {
      return this.$store.getters.UserLogin;
    },
    PaymentResponse() {
      let payment = [];
      payment = [{ account: "cod" }];
      payment = payment.concat({ account: "qr" });
      payment = payment.concat({ account: "creditcard" });
      payment = payment.concat(this.BranchDetail.paymentBank);
      return payment;
    },
    UserCardList() {
      let UserCardList = this.$store.getters.UserCardList;
      return UserCardList;
    },
    DialogUserConfirm() {
      return this.$store.getters.DialogUserConfirm;
    },
    SuggestionDetail() {
      return this.$store.getters.SuggestionDetail;
    },
    DistanceInfo() {
      return this.$store.getters.DistanceInfo;
    },
    DialogMinimumPrice() {
      return this.$store.getters.DialogMinimumPrice;
    },
    DialogOverDistance() {
      return this.$store.getters.DialogOverDistance;
    },
    DeliveryNote() {
      return this.$store.getters.DeliveryNote;
    },
    PickupNote() {
      return this.$store.getters.PickupNote;
    },
    roundingType() {
      return this.$store.getters.roundingType;
    },
  },
  watch: {
    isOpenDialog(curretnValue) {
      if (curretnValue) {
        this.displayConfirmOrder = true;
      } else {
        this.displayConfirmOrder = false;
      }
    },
    UserLineInfo() {},
    DialogOverDistance() {},
    DialogMinimumPrice() {},
    CachePreorderTime() {},
    PreOrderDetail() {},
    SuggestionDetail() {},
    DistanceInfo() {},
    PaymentType() {},
    UserCardList() {},
    AmountCart() {},
    // AmountCart (value) {
    //   this.Objoption = value
    // },
    TotalCartPrice(value) {
      // Get API deliveryfee When DistanceMatrix Not NULL
      if (this.DistanceInfo !== null) {
        this.$store
          .dispatch("getDistanceInfo", {
            distance: this.DistanceInfo.dis_metre * 1000,
            total: value,
            location: this.selectedLocation,
            restaurant: this.BranchDetail.restaurantId,
            branch: this.BranchDetail.id,
          })
          .then((response) => {
            if (typeof response != "undefined") {
              this.distanceStatus = response.status;
              this.checkStatus(response)
            }
          });
      }
    },
    DialogUserConfirm(value) {
      if (value) {
        this.$store.commit("setConfirmDialog", [false]);
        this.$store.commit("setDialogUserConfirm", false);
      }
    },
    orderType(value) {
      if (value) {
        this.$store.dispatch("setDelivery", "delivery");
      } else {
        this.$store.dispatch("setDelivery", "pick-up");
      }
      if (this.DistanceInfo !== null) {
        this.$store
          .dispatch("getDistanceInfo", {
            distance: this.DistanceInfo.dis_metre * 1000,
            total: this.TotalCartPrice,
            location: this.selectedLocation,
            restaurant: this.BranchDetail.restaurantId,
            branch: this.BranchDetail.id,
          })
          .then((response) => {
            if (typeof response != "undefined") {
              this.distanceStatus = response.status;
              this.checkStatus(response)
            }
          });
      }
    },
    is_map() {
      const location = JSON.parse(localStorage.getItem("fsloc"));
      if (location !== null && typeof location !== "undefined") {
        this.selectedLocation = location;
        // this.AddAddress = location.address
        // this.lat = location.lat
        // this.lng = location.lng
      }
    },
    UserLogin(user) {
      if (user) {
        this.stampLineLogin();
      }
    },
    InputDeliveryNote(value) {
      if (value != "") {
        this.InputDeliveryNote = value;
        this.$store.dispatch("setDeliveryNote", value);
      }
    },
    InputPickupNote(value) {
      if (value != "") {
        this.InputPickupNote = value;
        this.$store.dispatch("setPickupNote", value);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.overide-textarea {
  /deep/ {
    .el-textarea__inner {
      resize: none;
      padding: 8px 12px;
      border-radius: 7px;
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cart/CheckoutCart.vue